module.exports = __webpack_public_path__ + "static/media/reglas.a5eacd83.svg";